import React, { useState } from "react";
import PropTypes from "prop-types";

import { FormAside } from "../../components/form-components/FormAside/FormAside";
import FormContainer from "../../components/form-components/FormContainer";
import { Button } from "../../components/Button";
import Link from "../../components/Link";

import { ContactForm } from "../../forms/ContactForm/ContactForm";
import { TicketOrderForm } from "../../forms/TicketOrderForm/TicketOrderForm";
import { DownloadForm } from "../../forms/DownloadForm/DownloadForm";
import { SensorikForm } from "../../forms/SensorikForm/SensorikForm";
import { ThermografieForm } from "../../forms/ThermografieForm/ThermografieForm";
import { SeminarRegistrationForm } from "../../forms/SeminarRegistrationForm/SeminarRegistrationForm";
import { RegistrationForm } from "../../forms/RegistrationForm/RegistrationForm";

import FormLayoutContext from "./context";

import t from "../../lib/translate";

import * as styles from "./component.module.less";

const formMap = {
    /*
            Example structure:
            formId: <FormComponent>
        */
    // "form-example": ExampleForm,
    "contact-form": ContactForm,
    "ticket-order-form": TicketOrderForm,
    "download-form": DownloadForm,
    "sensor-form": SensorikForm,
    "thermography-form": ThermografieForm,
    "training-form": SeminarRegistrationForm,
    "registration-form": RegistrationForm,
};

function StandardFormLayout({ formId, locationState, locale, data, children }) {
    const [showSubmit, setShowSubmit] = useState(true);
    const [isSending, setIsSending] = useState(false);
    const [sendable, setSendable] = useState(formId !== "registration-form");

    const ctx = {
        showSubmit,
        setShowSubmit
    };

    const FormComponent = formMap[formId] || (() => null);

    return (
        <>
            <div className={styles.formPage}>
                <main className={styles.formContent}>
                    <div className={styles.formLogoBlock}>
                        <Link
                            to="/"
                            linkClass={styles.formLogo}
                            aria-label={t("page.forms.logo")}
                        />
                    </div>

                    <FormAside />

                    <div className={styles.formWrapper}>
                        <FormContainer>
                            <FormLayoutContext.Provider value={ctx}>
                                <FormComponent
                                    locationState={locationState}
                                    formId={formId}
                                    locale={locale}
                                    data={data}
                                    isSending={setIsSending}
                                    sendable={setSendable}
                                />
                            </FormLayoutContext.Provider>
                        </FormContainer>

                        <footer className={styles.formButtonsWrapper}>
                            {showSubmit && (
                                <div className={styles.formButtons}>
                                    <Button
                                        type="cta"
                                        form={formId}
                                        className={isSending || !sendable ? styles.formSubmitDisabled : styles.formSubmit}
                                        htmlType="submit"
                                        disabled={isSending || !sendable}
                                    >
                                        {t`page.forms.submit-button`}
                                    </Button>
                                </div>
                            )}
                        </footer>
                    </div>
                </main>
            </div>

            {children}
        </>
    );
}

StandardFormLayout.propTypes = {
    formId: PropTypes.string.isRequired
};

export { StandardFormLayout };
